import styled from "styled-components";

export const StyledButton = styled.button`
  display: flex;
  padding: 15px !important;
  justify-content: center !important;
  align-items: center !important;
  color: ${({ theme }) => theme.colors.dark} !important;
  font-size: ${({ theme }) => theme.fontSize.m} !important;
  background: transparent !important;
  cursor: pointer !important;
  border: none !important;
  text-decoration: underline !important;
  text-underline-offset: 3px !important;
  transition. 0.2s ease-in-out;
  white-space: wrap !important;
  &:hover{
    opacity: 0.7 !important;
  }
`;
